import type { DateRangePickerProps } from '@prerender/design-system/DateRangePicker';

import { timeFrameNameForAnalytics } from './dateRangeLabel';

export type DatePickerEventMap = {
  PresetClicked: { preset: string };
  PeriodStepped: { direction: string; period: string };
  PeriodReset: { from: string };
};

type DatePickerEventArgs = {
  [E in keyof DatePickerEventMap]: [event: E, properties: DatePickerEventMap[E]];
}[keyof DatePickerEventMap];

export type DatePickerTracker = (...args: DatePickerEventArgs) => void;

type PickerTrackEvent = NonNullable<DateRangePickerProps['trackEvent']>;
type PickerEventProperties = Parameters<PickerTrackEvent>[1];

export function toDatePickerTracker(track: DatePickerTracker): PickerTrackEvent {
  const forward: Record<keyof DatePickerEventMap, (properties: PickerEventProperties) => void> = {
    PresetClicked: (properties) => track('PresetClicked', { preset: String(properties.preset) }),
    PeriodStepped: (properties) =>
      track('PeriodStepped', {
        direction: String(properties.direction),
        period: timeFrameNameForAnalytics(String(properties.period)),
      }),
    PeriodReset: (properties) => track('PeriodReset', { from: timeFrameNameForAnalytics(String(properties.from)) }),
  };

  return (name, properties) => forward[name](properties);
}
